import React, { useState } from "react";
import { MdOutlineChangeCircle } from "react-icons/md";
import { IoMdRemoveCircleOutline } from "react-icons/io";
import { IoIosSave } from "react-icons/io";
import { TbLoader3 } from "react-icons/tb";
import { useSelector } from "react-redux";
import { SaveForPass } from "../../../../apis";
import { toast } from "react-toastify";

function PassChange() {
  const [editPassword, setEditPassword] = useState(false);
  const [newPass, setNewPass] = useState("");
  const [loading, setLoading] = useState(false);
  const user = useSelector((state) => state.user.user);

  const handleSavePassword = async () => {
    if (!newPass.trim()) {
      toast.warn("Password cannot be empty");
      return;
    }

    setLoading(true);
    const res = await SaveForPass(user?.email, newPass);

    if (res.error) {
      toast.error("Unable to save password, try again later...");
    } else {
      toast.success("Password changed successfully");
      setEditPassword(false);
      setNewPass("");
    }

    setLoading(false);
  };

  return (
    <div className="flex flex-col gap-3 mt-3 text-sm sm:text-base">
      {!editPassword ? (
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3">
          <div className="flex gap-2 text-gray-700">
            <span className="font-medium">Current Password:</span>
            <span className="tracking-wider italic">***********</span>
          </div>
          <button
            onClick={() => setEditPassword(true)}
            className="flex items-center gap-1 px-3 py-1 border rounded-md text-sm bg-white hover:bg-slate-100 border-gray-300 shadow-sm">
            <MdOutlineChangeCircle className="w-5 h-5" />
            Update
          </button>
        </div>
      ) : (
        <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
          <label htmlFor="newPass" className="font-medium">
            New Password:
          </label>
          <input
            id="newPass"
            className="bg-slate-100 rounded-lg px-3 py-1 outline-none border border-gray-300 focus:ring-2 focus:ring-blue-400 w-full sm:w-64"
            name="newPass"
            value={newPass}
            type="password"
            onChange={(e) => setNewPass(e.target.value)}
            placeholder="Enter new password"
          />

          <div className="flex gap-2">
            <button
              onClick={handleSavePassword}
              disabled={loading}
              className={`flex items-center gap-1 px-3 py-1 rounded text-white shadow-md transition ${
                loading
                  ? "bg-gray-400 cursor-not-allowed"
                  : "bg-blue-600 hover:bg-blue-700"
              }`}>
              {loading ? (
                <TbLoader3 className="w-5 h-5 animate-spin" />
              ) : (
                <IoIosSave className="w-5 h-5" />
              )}
              {loading ? "Saving..." : "Save"}
            </button>

            <button
              onClick={() => {
                setEditPassword(false);
                setNewPass("");
              }}
              className="flex items-center gap-1 px-3 py-1 bg-red-500 hover:bg-red-600 text-white rounded shadow-md transition">
              <IoMdRemoveCircleOutline className="w-5 h-5" />
              Cancel
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default PassChange;
